import { ButtonComponentConfig } from '@rappider/rappider-components/utils';

export const UIDataEventDetailsButtonConfig: ButtonComponentConfig = {
  text: 'See UI Data Event Details',
  block: true
};
